import type { IQuestionDifficultyLevelsEnum } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IResponseOption } from "@/interfaces";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IQuestionDifficultyLevelsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.questionDifficultyLevels");

export const questionDifficultyLevels = {
  ...getAllApis,
};
